import { useMutation, UseMutationOptions } from 'react-query'
import { AxiosError } from 'axios'
import axios from 'axios'
import { useAuth0 } from 'app/Auth'
import { ImportPhysiciansPayload, ImportPhysiciansResponse } from './types'

const importPhysiciansMutationFn = async (
  payload: ImportPhysiciansPayload,
  getAccessToken: () => Promise<string>
): Promise<ImportPhysiciansResponse> => {
  const formData = new FormData()
  formData.append('file', payload.file)

  const token = await getAccessToken()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  if (!REPORTS_URL) {
    throw new Error(
      'REACT_APP_REPORTS_URL is not defined in environment variables.'
    )
  }

  const response = await axios.post<ImportPhysiciansResponse>(
    `${REPORTS_URL}api/v1/import/patient-physician`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const useImportPhysicians = (
  options?: UseMutationOptions<
    ImportPhysiciansResponse,
    AxiosError,
    ImportPhysiciansPayload
  >
) => {
  const { getAccessToken } = useAuth0()

  return useMutation<
    ImportPhysiciansResponse,
    AxiosError,
    ImportPhysiciansPayload
  >(
    (data: ImportPhysiciansPayload) =>
      importPhysiciansMutationFn(data, getAccessToken),
    options
  )
}
